export default __webpack_public_path__ + "static/media/Digital Keys.8dae7bbe.svg";